import api from '../config/api';

interface CartItem {
  id: number;
  product_id: number;
  quantity: number;
  price: number;
  product?: {
    id: number;
    name: string;
    sku: string;
    image_url?: string;
  };
}

interface Cart {
  id: number;
  items: CartItem[];
  total_amount: number;
  created_at: string;
  updated_at: string;
}

// Helper to dispatch cart update event
const notifyCartUpdate = () => {
  window.dispatchEvent(new Event('cartUpdated'));
};

const cartService = {
  async getCart(): Promise<Cart> {
    const response = await api.get('/cart');
    return response.data;
  },

  async addToCart(productId: number, quantity: number): Promise<Cart> {
    const response = await api.post('/cart/add', {
      product_id: productId,
      quantity
    });
    notifyCartUpdate();
    return response.data;
  },

  async updateCartItem(itemId: number, quantity: number): Promise<Cart> {
    const response = await api.put(`/cart/items/${itemId}`, {
      quantity
    });
    notifyCartUpdate();
    return response.data;
  },

  async removeFromCart(itemId: number): Promise<Cart> {
    const response = await api.delete(`/cart/items/${itemId}`);
    notifyCartUpdate();
    return response.data;
  },

  async clearCart(): Promise<{ message: string }> {
    const response = await api.delete('/cart');
    notifyCartUpdate();
    return response.data;
  }
};

export default cartService;